export default __webpack_public_path__ + "static/media/chargebee-logo-toolbox.2dfea035.svg";